module.exports = __webpack_public_path__ + "img/05.11b3e807.svg";